module.exports = __webpack_public_path__ + "images/content/organize_your_contacts.gif";